//Components
import { Toast } from 'react-bootstrap';

//Styles
import './styles.scss'

interface ActivityToastProps {
  autohide?: number;
  message: string;
  open: boolean;
  onClose: Function;
}

const ActivityToast = (props: ActivityToastProps) => {
  const { autohide, message, open, onClose } = props;

  return (
    <Toast
      className="toast"
      animation={false}
      onClose={() => onClose()}
      show={open}
      delay={autohide}
      autohide={autohide !== undefined}
    >
      <Toast.Body>{message}</Toast.Body>
    </Toast>
  )
}

export default ActivityToast;
